import { sanitizeHTML } from './contentSanitizer';

export function markdownToHTML(markdown: string): string {
  let html = markdown;

  html = html.replace(/^### (.*$)/gim, '<h3>$1</h3>');
  html = html.replace(/^## (.*$)/gim, '<h2>$1</h2>');

  html = html.replace(/\*\*\*(.*?)\*\*\*/g, '<strong><em>$1</em></strong>');
  html = html.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
  html = html.replace(/\*(.*?)\*/g, '<em>$1</em>');

  html = html.replace(/^> (.*$)/gim, '<blockquote>$1</blockquote>');

  html = html.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2">$1</a>');

  html = html.replace(/^---$/gim, '<hr>');
  html = html.replace(/^___$/gim, '<hr>');

  const lines = html.split('\n');
  let inList = false;
  let listType: 'ul' | 'ol' | null = null;
  const processed: string[] = [];

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    const unorderedMatch = line.match(/^[\*\-\+] (.+)$/);
    const orderedMatch = line.match(/^\d+\. (.+)$/);

    if (unorderedMatch) {
      if (!inList || listType !== 'ul') {
        if (inList && listType) processed.push(`</${listType}>`);
        processed.push('<ul>');
        listType = 'ul';
        inList = true;
      }
      processed.push(`<li>${unorderedMatch[1]}</li>`);
    } else if (orderedMatch) {
      if (!inList || listType !== 'ol') {
        if (inList && listType) processed.push(`</${listType}>`);
        processed.push('<ol>');
        listType = 'ol';
        inList = true;
      }
      processed.push(`<li>${orderedMatch[1]}</li>`);
    } else {
      if (inList && listType) {
        processed.push(`</${listType}>`);
        inList = false;
        listType = null;
      }
      if (line.trim() === '') {
        processed.push('<br>');
      } else if (!line.match(/^<(h2|h3|blockquote|hr)/)) {
        if (line.trim() !== '') {
          processed.push(`<p>${line}</p>`);
        }
      } else {
        processed.push(line);
      }
    }
  }

  if (inList && listType) {
    processed.push(`</${listType}>`);
  }

  html = processed.join('\n');

  html = html.replace(/<\/blockquote>\n<blockquote>/g, '\n');

  html = html.replace(/<br>\n<br>/g, '<br>');

  return sanitizeHTML(html);
}
